module.exports = __webpack_public_path__ + "images/emoji/phone.c48bb7af3f6afdf42dd3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/phone.png
// module id = HLz9
// module chunks = 2